<template>
    <div>
        <a class="btn btn-xl btn-outline-primary btn-round mr-1 mb-2 mb-lg-0 text-uppercase" href="#curricula">{{ $t("coursesPage.curriculaBtn") }}</a>
        <router-link class="btn btn-xl btn-secondary btn-round text-uppercase" to="/register">{{ $t("nav.registerBtn") }}</router-link>
    </div>
</template>

<script>
export default {
  name: "coursesCtaBtns"
};
</script>
